import React, { Dispatch, SetStateAction } from 'react';
import { Box, Grid, Button, Typography } from '@material-ui/core';
import { ABOUT_YOU } from 'constants/textsSteps';
import ModalInfo from 'components/ModalInfo/ModalInfo';

interface TermPolicyProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onAccept: () => void;
  onClose: () => void;
}

const TermPolicy = ({ open, setOpen, onAccept, onClose }: TermPolicyProps) => {
  const { termPolicy } = ABOUT_YOU;

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  return (
    <ModalInfo open={open} className="term-modal" onClose={handleClose} noPadding>
      <Box p={6}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box mb={3}>
              <Typography variant="h5" color="primary">
                {termPolicy.title}
              </Typography>
            </Box>

            {termPolicy.body.map((item) => (
              <Box mb={3} key={`term-policy-introductory-${item}`}>
                <Typography variant="body2" align="left" className="text-term">
                  {item}
                </Typography>
              </Box>
            ))}
          </Grid>
        </Grid>

        <Box mt={3}>
          <Grid container className="flex-center">
            <Grid item xs={2}>
              <Button
                className="button-term"
                color="primary"
                title="Começar"
                variant="text"
                fullWidth
                onClick={handleClose}
                data-testid="button-back-policy-introductoryStep"
              >
                Voltar
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                className="button-term"
                color="primary"
                title="Começar"
                variant="contained"
                fullWidth
                id="residencial-site-termos-nomesocial-aceito"
                onClick={onAccept}
              >
                Li e Aceito
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </ModalInfo>
  );
};

export default TermPolicy;
